export default __webpack_public_path__ + "static/media/WNLProto4.d596ffe3.png";